import {Brick, registerBrick} from 'olympe';

export default class Today extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function(string)} setToday
     */
    update($, inputs, [setToday]) {
        const today = new Date();
        setToday(today.toISOString().split('T')[0]);
    }
}

registerBrick('017f9dc4df1765f6a01a', Today);
